/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/12
 */
import React from 'react';

const CircleTick = () => {
  return <svg viewBox="0 0 1024 1024" className="store-svg-circletick">
    <path d="M512 46.645c255.949 0 465.355 209.408 465.355 465.355s-209.408 465.355-465.355 465.355-465.355-209.408-465.355-465.355 209.408-465.355 465.355-465.355M512 0.112c-283.862 0-511.888 228.025-511.888 511.888s228.025 511.888 511.888 511.888 511.888-228.025 511.888-511.888-228.025-511.888-511.888-511.888v0z"/>
    <path d="M281.535 508.097l197.43 197.43-32.907 32.907-197.43-197.43 32.907-32.907z"/>
    <path d="M774.206 411.526l-329.053 329.053-32.907-32.907 329.053-329.053 32.907 32.907z"/>
  </svg>
};

export default CircleTick;



// WEBPACK FOOTER //
// ./src/svgs/circleTick.js